(function () {
  'use strict';

  function plTrack(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
  }

  function attachListener() {
    const cartDrawer = document.querySelector('.m-cart-drawer__inner')
      || document.querySelector('#cart-drawer')
      || document;

    cartDrawer.addEventListener('click', function (e) {

    // Trigger button
const trigger = e.target.closest('.pl-autoship-upsell__trigger');
if (trigger) {
  const upsell = trigger.closest('.pl-autoship-upsell');
  const panel = upsell.querySelector('.pl-autoship-upsell__panel');
  const isOpen = trigger.getAttribute('aria-expanded') === 'true';

  trigger.setAttribute('aria-expanded', String(!isOpen));
  panel.classList.toggle('is-open', !isOpen);

  if (!isOpen) {
    plTrack('pl_autoship_open', {
      item_key: upsell.dataset.itemKey,
      variant_id: upsell.dataset.variantId,
    });
  }
  return;
}

     // Confirm button
const confirmBtn = e.target.closest('.pl-autoship-upsell__confirm');
if (confirmBtn) {
  const upsell = confirmBtn.closest('.pl-autoship-upsell');
  const selectedBtn = upsell.querySelector('.pl-autoship-upsell__freq-btn.is-selected');
  const itemKey = upsell.dataset.itemKey;

  if (!selectedBtn) return;

  const sellingPlanId = parseInt(selectedBtn.dataset.sellingPlanId, 10);
  if (!sellingPlanId) return;

  confirmBtn.disabled = true;
  confirmBtn.textContent = 'Updating…';

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: itemKey, selling_plan: sellingPlanId }),
  })
    .then((res) => {
      if (!res.ok) throw new Error('Cart update failed');
      return res.json();
    })
    .then((cartData) => {
      plTrack('pl_autoship_converted', {
        item_key: itemKey,
        variant_id: upsell.dataset.variantId,
        selling_plan_id: sellingPlanId,
        selling_plan_name: selectedBtn.textContent.trim(),
      });

      const subtotalEl = document.querySelector(
        '.m-cart__subtotal-price, .m-mini-cart__subtotal .m-price, [data-cart-subtotal]'
      );
      if (subtotalEl && cartData.total_price) {
        subtotalEl.textContent = (cartData.total_price / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: cartData.currency,
        });
      }

      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
    })
    .catch((err) => {
      console.error('[PL Autoship]', err);
      confirmBtn.disabled = false;
      confirmBtn.textContent = 'Confirm Autoship';
      alert('Something went wrong. Please try again.');
    });

  return;
}

// Frequency button selection
const freqBtn = e.target.closest('.pl-autoship-upsell__freq-btn');
if (freqBtn) {
  const upsell = freqBtn.closest('.pl-autoship-upsell');
  upsell.querySelectorAll('.pl-autoship-upsell__freq-btn').forEach((btn) => {
    btn.classList.remove('is-selected');
    btn.setAttribute('aria-pressed', 'false');
  });
  freqBtn.classList.add('is-selected');
  freqBtn.setAttribute('aria-pressed', 'true');

  plTrack('pl_autoship_frequency_selected', {
    item_key: upsell.dataset.itemKey,
    selling_plan_id: freqBtn.dataset.sellingPlanId,
    selling_plan_name: freqBtn.textContent.trim(),
  });

  return;
}
// Cancel button
const cancelBtn = e.target.closest('.pl-autoship-upsell__cancel');
if (cancelBtn) {
  const upsell = cancelBtn.closest('.pl-autoship-upsell');
  const trigger = upsell.querySelector('.pl-autoship-upsell__trigger');
  const panel = upsell.querySelector('.pl-autoship-upsell__panel');

  trigger.setAttribute('aria-expanded', 'false');
  panel.classList.remove('is-open');

  plTrack('pl_autoship_dismissed', {
    item_key: upsell.dataset.itemKey,
    variant_id: upsell.dataset.variantId,
  });

  return;
}

    });
  }

  // .m-cart-drawer__inner is injected dynamically, so wait for it
  function waitForDrawer() {
    const el = document.querySelector('.m-cart-drawer__inner');
    if (el) {
      attachListener();
      return;
    }
    // Poll until it exists — typically renders on first cart open
    const interval = setInterval(() => {
      if (document.querySelector('.m-cart-drawer__inner')) {
        clearInterval(interval);
        attachListener();
      }
    }, 200);
  }

  // Impression tracking via MutationObserver
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        const upsells = node.matches?.('.pl-autoship-upsell')
          ? [node]
          : [...(node.querySelectorAll?.('.pl-autoship-upsell') || [])];

        upsells.forEach(function (upsell) {
          if (upsell.dataset.plImpression) return;
          upsell.dataset.plImpression = 'true';
          plTrack('pl_autoship_impression', {
            item_key: upsell.dataset.itemKey,
            variant_id: upsell.dataset.variantId,
          });
        });
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', waitForDrawer);

})();